<template>
  <div>
    <b-row class="physical-meeting-info-row mt-5">
      <b-col>
        <p>
          {{
            ft(
              featureName,
              'reportingChannels.physicalMeeting.createDescription',
              $t
            )
          }}
        </p>
      </b-col>
    </b-row>
    <b-row class="email-row mt-5 col-12 col-md-6">
      <b-col>
        <puls-form-input
          v-model="email"
          type="email"
          placeholder="name@example.com"
          autocomplete="new-password"
          :label="ft(featureName, 'create.email.label', $t)"
          :is-floating-label="true"
          class="mb-7"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import isValidEmailAddress from '../helpers/create-report-form-helper'
import LocalizableComponent from './LocalizableComponent.vue'

export default {
  name: 'PhysicalMeetingForm',
  extends: LocalizableComponent,
  props: {
    onChange: {
      type: Function,
      default: () => {}
    },
    initialFormData: {
      type: Object,
      default: null
    },
    featureName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      email: null
    }
  },
  computed: {
    validForm() {
      return isValidEmailAddress(this.email)
    }
  },
  watch: {
    validForm() {
      if (this.validForm) {
        this.handleUpdatedFormData()
      }
    },
    email(newEmail) {
      if (newEmail) {
        this.handleUpdatedFormData()
      }
    }
  },
  mounted() {
    if (this.initialFormData && this.initialFormData.email) {
      this.email = this.initialFormData.email
    }
  },
  methods: {
    handleUpdatedFormData() {
      const formData = {
        message: this.ft(
          this.featureName,
          'reportingChannels.physicalMeeting.message',
          this.$t
        ),
        email: this.email
      }
      this.onChange({ validForm: this.validForm, formData })
    }
  }
}
</script>
<style scoped></style>
